import React, { useState, useEffect } from 'react';
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
import {toastMessage} from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { clearSession } from '../../utils/initiate';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import '../../assets/table.css';
import * as deliveryActions from '../../Redux/Actions/delivery';
import UpdateDeliveryModal from './updateDeliveryModal';
import { getCookie } from '../../utils/cookie';

const DeliveryManagement = ({history}) => {

    let itemsPerPage = 10;
    const [data, setData] = useState([]);
    const [type, setType] = useState('');
    const [filterID, setFilterID] = useState('');
    const [filterRefNum, setFilterRefNum] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [statusOption, setStatusOption] = useState([]);
    const { t } = useTranslation();
    const [updateDeliveryModal, setUpdateDeliveryModal] = useState(false);
    const [referenceEditData, setReferenceEditData] = useState({});
    const [filter, setFilter] = useState(0);

    const handleGetAllDelivery = () => {
        
        setLoading(true);
        let payload = {
            deliveryReference : filterRefNum,
            status : selectedStatus,
            createDate : '',
            updateByID : 0,
            jobid : filterID
        };

        jobsActions.deliveryRequest(payload).then(res => {
            if(res && res.data) {
                let jobData = [];
                res.data.map((form, index) => jobData.push({'sno': index+1, ...form}));
                setData(jobData);
            } else {
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the delivery`);
            }
            setLoading(false);
            setType('');
        }).catch(err => {
             setErrStatus(err.response.status);
             (err.response.status === 401) && clearSession(dispatch, history);
            console.log(err);
        });
    };

    const {items, requestSort, sortConfig} = useSortableData(data);
    
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    const handleClearFilter = () => {
            setFilterID('');
            setFilterRefNum('');
            setSelectedStatus('');
            setFilter(0);
    };

    const filterHandler = () => {
        if(filterID || filterRefNum || selectedStatus) {
            setFilter(filter + 1);
        }
    };

    useEffect(() => {
        handleGetAllDelivery();
        handleStatusFilter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    if(errStatus === 400){
        return <Warning history={history} />
    }

    const handleStatusFilter = () => {

        jobsActions.getAllDeliveryTypeAndStatus().then(res => {
            if(res && res.data) {
                setStatusOption(res.data.deliveryStatus);
            } else {
                console.log('No data exist in deliverystatus');
            }
        }).catch( err => console.log(err));
    }

    const handleCreateDeliveryReq = (formURL) => {
        window.open(`${formURL}&token=${getCookie('jwt')}`, '_blank');
    };
    
    return(
        <>
            {(type === '') && <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("deliveryManagement.manageDelivery.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.labelJobID")}</label>
                                                <input placeholder={t("jobsManagement.filters.enterID")} type="number" className="form-control me-3" name="Filter ID" value={filterID} onChange={(e) => {setFilterID(e.target.value)}} />
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.referenceNumber")}</label>
                                                <input placeholder={t("jobsManagement.filters.enterReferenceNumber")} type="text" className="form-control me-3" name="Filter ID" value={filterRefNum} onChange={(e) => {setFilterRefNum(e.target.value)}}/>
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.status")}</label>
                                                <select className="form-select me-3" value={selectedStatus} onChange={(e) => {setSelectedStatus(e.target.value)}}>
                                                    <option value="" disabled={true}>{t("jobsManagement.filters.selectJobStatus")}</option>
                                                    {statusOption.map((option) => (<option key={option.value} value={option.value}>{option.lable}</option>))}
                                                </select>
                                            </div>
                                            <div className="d-flex align-items-end" style={{whiteSpace: 'nowrap'}}>
                                                <button onClick={filterHandler} type="button" className="d-flex me-3 px-4 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                            </div>
                                            <div className="d-flex align-items-end" style={{whiteSpace: 'nowrap'}}>
                                                <button onClick={e => handleClearFilter()}type="button" className="d-flex align-items-center btn btn-secondary font-weight-bold" >{t("jobsManagement.filters.clearFilters")}</button>
                                            </div>
                                        </div>
                                    </div>
                                    {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                                        : <div className="table-responsive" style={{width: '100%', overflowX:'scroll'}}>
                                        <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                                            <thead>
                                                <tr className="text-left" >
                                                    <th className="c-pointer pl-7" style={{width: '60px'}} onClick={() => requestSort('sno')}>
                                                        <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-primary" : "text-dark-75"}>{t("jobsManagement.manageJobs.sNo")} {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                                    </th>
                                                    <th className="c-pointer" style={{width: '150px', textAlign: 'center'}} onClick={() => requestSort('referenceNumber')}><span className={(sortConfig && (sortConfig.key === 'referenceNumber')) ? "text-secondary" : "text-dark-75"}>{t("deliveryManagement.manageDelivery.refNo")} {(sortConfig && (sortConfig.key === 'referenceNumber')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '75px', textAlign: 'center'}} onClick={() => requestSort('id')}><span className={(sortConfig && (sortConfig.key === 'id')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.id")} {(sortConfig && (sortConfig.key === 'id')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px', textAlign: 'center'}} onClick={() => requestSort('type')}><span className={(sortConfig && (sortConfig.key === 'type')) ? "text-secondary" : "text-dark-75"}>{t("deliveryManagement.manageDelivery.deliveryType")} {(sortConfig && (sortConfig.key === 'type')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px', textAlign: 'center'}} onClick={() => requestSort('emiratePostReferenceNumber')}><span className={(sortConfig && (sortConfig.key === 'emiratePostReferenceNumber')) ? "text-secondary" : "text-dark-75"}>{t("deliveryManagement.manageDelivery.emiratePostReferenceNumber")} {(sortConfig && (sortConfig.key === 'emiratePostReferenceNumber')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px', textAlign: 'center'}} onClick={() => requestSort('documents')}><span className={(sortConfig && (sortConfig.key === 'documents')) ? "text-secondary" : "text-dark-75"}>{t("deliveryManagement.manageDelivery.documents")} {(sortConfig && (sortConfig.key === 'documents')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px', textAlign: 'center'}} onClick={() => requestSort('status')}><span className={(sortConfig && (sortConfig.key === 'status')) ? "text-secondary" : "text-dark-75"}>{t("deliveryManagement.manageDelivery.status")} {(sortConfig && (sortConfig.key === 'status')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th style={{width: '100px', position:'sticky', left:'0px',zIndex:'40', textAlign: 'center'}}><span className="text-dark-75">{t("jobsManagement.manageJobs.action")}</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems.map(({sno, jobId, type, status, referenceNumber, emiratePostReferenceNumber, documents, formData}) => {
                                                    return(
                                                        <tr key={sno}>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{referenceNumber}</span>
                                                            </td>
                                                            <td>
                                                                <span onClick={() => {history.push(`/jobs/${jobId}`); dispatch(deliveryActions.Delivery({formData}))}} className="text-info c-pointer font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{jobId}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{type}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{!!emiratePostReferenceNumber ? emiratePostReferenceNumber : '-' }</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{!!documents ? documents : '-' }</span>
                                                            </td>
                                                            <td> 
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{status}</span>
                                                            </td>
                                                            <td> 
                                                            <button style={{minWidth: '100px'}} className="btn btn-primary me-2" onClick={() => {setUpdateDeliveryModal(true); setReferenceEditData({sno, jobId, type, status, referenceNumber, emiratePostReferenceNumber, documents, formData});}}>{t("jobsManagement.infoJob.createDeliveryRequest.update")}</button>
                                                            <button style={{minWidth: '100px'}} className="btn btn-primary me-2" onClick={() => {handleCreateDeliveryReq(formData)}}>{t("jobsManagement.infoJob.createDeliveryRequest.title")}</button>
                                                            </td>
                                                        </tr>
                                                    )})}
                                            </tbody>
                                        </table>
                                        {(pageCount > 1) && <ReactPaginate
                                            breakLabel="..."
                                            nextLabel=">"
                                            previousLabel="<"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            containerClassName="pagination"
                                            activeClassName="active"
                                            renderOnZeroPageCount={null}
                                        />}
                                        {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("jobsManagement.noDataAvailable")}</p>}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {updateDeliveryModal && <UpdateDeliveryModal 
                t={t} 
                showModal={updateDeliveryModal}
                // loading={buttonLoading}
                statusOptions={statusOption}
                // handleOk={handleUpdateReferenceStatus} 
                handleCancel={() => setUpdateDeliveryModal(false)} 
                referenceEditData={referenceEditData} 
                />}
            </div>}
        </>
    );
};

export default DeliveryManagement;